import Store from 'store/store';
import { addClass, removeClass } from 'utils/utils';

Store.on('OPEN_PREVIEW_PANEL_PROVIDER_INTERSTITIAL', (data) => {
	Store.get().previewPanel.set({
		providerInterstitialOpen: true,
		selectedScreening: data.screening,
		selectedTheater: data.theater
	});
	const isDesktopSize = Store.get().client.isDesktopSize;
	if (!isDesktopSize) {
		addClass(document.body, 'locked');
	}

	Store.emit('TOGGLE_INTERSTITIAL_OPEN', true);
});

Store.on('CLOSE_PREVIEW_PANEL_PROVIDER_INTERSTITIAL', () => {
	removeClass(document.body, 'locked');
	Store.get().previewPanel.set({
		providerInterstitialOpen: false,
		selectedScreening: {},
		selectedTheater: {}
	});

	Store.emit('TOGGLE_INTERSTITIAL_OPEN', false);
});